'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preview = require('./preview');

var _preview2 = _interopRequireDefault(_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _preview2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/core/dist/client/index.js
// module id = 1030
// module chunks = 0